export default {
    questionDataBegin(state) {
        state.loadingQuestion = true;
        state.errorQuestion = false;
    },
    questionDataSuccess(state, data) {
        state.question = data;
        state.showEdit = true;
        state.loadingQuestion = false;
    },
    questionDataErr(state, err) {
        state.loadingQuestion = false;
        state.errorQuestion = err;
    },
    questionsDataBegin(state, query) {
        if (query) state.listQuery = query;
        state.loadingQuestions = true;
    },
    questionsDataSuccess(state, data) {
        state.pageSize = Number((data.meta || data).per_page) || state.pageSize;
        state.questions = data.data;
        state.count = data.meta ? data.meta.total : data.total || 0;
        state.currentPage = data.meta ? data.meta.current_page : data.current_page || 1;
        state.loadingQuestions = false;
    },
    questionsDataErr(state, err) {
        state.loadingQuestions = false;
        state.errorQuestions = err;
    },
    questionDataCreateBegin(state) {
        state.loadingCreateQuestion = true;
    },
    questionDataCreateSuccess(state) {
        state.loadingCreateQuestion = false;
        state.showEdit = false;
    },
    questionDataCreateErr(state, err) {
        state.loadingCreateQuestion = false;
        state.errorCreateQuestion = err;
    },
    questionDataPatchBegin(state) {
        state.loadingPatchQuestion = true;
    },
    questionDataPatchSuccess(state) {
        state.loadingPatchQuestion = false;
    },
    questionDataPatchErr(state, err) {
        state.loadingPatchQuestion = false;
        state.errorPatchQuestion = err;
    },
    questionDataDeleteBegin(state) {
        state.loadingDeleteQuestion = true;
    },
    questionDataDeleteSuccess(state) {
        state.loadingDeleteQuestion = false;
    },
    questionDataDeleteErr(state, err) {
        state.loadingDeleteQuestion = false;
        state.errorDeleteQuestion = err;
    },
    setCurrentPageQuestions(state, page) {
        state.currentPage = page;
    },
    setPageSizeQuestions(state, pageSize) {
        state.pageSize = pageSize;
    },
};
